"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";

export function Footer() {
  const t = useTranslations("footer");
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-border bg-card">
      <div className="container mx-auto px-4 py-8 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <p className="text-sm text-muted-foreground">
            {t("copyright", { year: currentYear })}
          </p>
          <nav className="flex flex-wrap items-center justify-center gap-6">
            <Link
              href="https://exawizards.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              {t("privacyPolicy")}
            </Link>
            <Link
              href="https://exawizards.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              {t("termsOfService")}
            </Link>
            <Link
              href={
                process.env.NEXT_PUBLIC_CONTACT_URL ||
                "https://exawizards.com/contact"
              }
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              {t("contact")}
            </Link>
            <Link
              href="https://exawizards.com/support"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              {t("support")}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
